import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { Checkbox } from '@mui/material';
import { ReactComponent as IconCheckbox } from './checkbox.svg';
import { ReactComponent as IconCheckboxChecked } from './checkboxChecked.svg';
import { ReactComponent as IconCheckboxIndeterminate } from './checkboxIndeterminate.svg';

CheckboxRound.propTypes = {
    sx: PropTypes.object,
    checked: PropTypes.bool,
    onChange: PropTypes.func,
    indeterminate: PropTypes.bool,
    id: PropTypes.string,
};
function CheckboxRound(props) {
    return (
        <Checkbox
            id={props.id || 'checkbox'}
            color="primary"
            indeterminate={props.indeterminate}
            checked={props.checked}
            onChange={props.onChange}
            icon={<IconCheckbox />}
            checkedIcon={<IconCheckboxChecked />}
            indeterminateIcon={<IconCheckboxIndeterminate />}
        />
    );
}

export default memo(CheckboxRound);
